import script from "./DirectivePdfViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectivePdfViewer.vue?vue&type=script&setup=true&lang=js"

import "./DirectivePdfViewer.vue?vue&type=style&index=0&id=9f2fe47a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f2fe47a"]])

export default __exports__